import {EventEmitter, IObservable} from '../index';

export class ObservableSet<V> extends Set<V> implements IObservable {

    private eventEmitter = new EventEmitter<IObservable.Events>();

    public get eventUpdated () {
        return this.eventEmitter.createEventReference('eventUpdated')
    }

    updateBatch (updateFunction: (observableSet: this) => void) {
        this.eventEmitter.batchEventEmitting('eventUpdated', () => {
            updateFunction(this);
        });
    }

    add (value: V) {
        const result = super.add(value);

        this.eventEmitter?.emit('eventUpdated');

        return result;
    }

    addMultiple (valuesArr: V[]) {

        let wasUpdated = false;

        for (const value of valuesArr) {
            if (!super.has(value)) {
                super.add(value);
                wasUpdated = true;
            }
        }

        if (wasUpdated) {
            this.eventEmitter.emit('eventUpdated');
        }

        return valuesArr;
    }

    deleteMultiple (valuesArr: V[]) {

        for (const value of valuesArr)
        {
            super.delete(value);
        }

        this.eventEmitter.emit('eventUpdated');

        return valuesArr;
    }

    intersect (values: Iterable<V>) {

        let updated = false;

        const valuesSet = new Set(values);
        const currentValues = [...this.values()];
        for (const currentValue of currentValues) {
            if (!valuesSet.has(currentValue)) {
                super.delete(currentValue);
                updated = true;
            }
        }

        if (updated) {
            this.eventEmitter.emit('eventUpdated');
        }
    }

    set (values: Iterable<V>) {

        let updated = false;

        const valuesSet = new Set(values);
        const currentValues = [...this.values()];
        for (const currentValue of currentValues) {
            if (!valuesSet.has(currentValue)) {
                super.delete(currentValue);
                updated = true;
            }
        }


        for (const newValue of values) {
            if (!super.has(newValue)) {
                super.add(newValue);
                updated = true;
            }
        }

        if (updated) {
            this.eventEmitter.emit('eventUpdated');
        }
    }

    clear () {
        super.clear();

        this.eventEmitter.emit('eventUpdated');
    }

    delete(value: V) {

        const result = super.delete(value);

        this.eventEmitter.emit('eventUpdated');

        return result;
    }

    toggleValue (value: V, isToggled?: boolean) {

        const wasToggled = this.has(value);
        const shouldBeToggled = isToggled ?? !wasToggled;

        if (shouldBeToggled !== wasToggled) {
            if (shouldBeToggled) {
                this.add(value);
            } else {
                this.delete(value);
            }
        }
    }

    isEmpty () {
        return this.size === 0;
    }

}
